import { createContext, useContext, useMemo } from 'react';
import { useAppContext } from '@/context/AppContext';
import { viewerTheme } from '@/theme/viewer-look';

/** The open page's own viewer look, set by the viewer around its chrome. */
export const ViewerLookContext = createContext(null);

/** The theme with the open page's own viewer parts on top. */
export function useViewerTheme(look) {
    const { theme } = useAppContext();
    const fromContext = useContext(ViewerLookContext);
    const pageLook = look === undefined ? fromContext : look;
    return useMemo(() => viewerTheme(theme, pageLook), [theme, pageLook]);
}
